
import { defineComponent, onMounted, ref, computed, getCurrentInstance } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { API_TCandidate_Summary } from "@/models/candidate";

export default defineComponent({
  name: "EmployeeCard",

  setup() {
    const instance = getCurrentInstance()?.proxy;
    const route = instance?.$route;

    const candidateId = computed(() => Number(route.params.candidateId ?? 0));

    const summaryLoading = ref(false);

    const summary = ref<API_TCandidate_Summary>({
      candidate_name: "",
      date_of_birth: "",
      email: "",
      job_position: "",
      visa_expiration_date: "",
      work_site: "",
    });

    async function fetchCandidateSummary() {
      if (!candidateId.value) return;

      try {
        summaryLoading.value = true;

        const { data } = await axios.get<API_TCandidate_Summary>(
          API_ROUTES.CANDIDATE_USER_SUMMARY(candidateId.value)
        );

        if (!data) return;

        Object.entries(data).forEach(([key, value]) => {
          summary.value[key] =
            value != null && typeof value === "string" && !/^\s*$/.test(value) ? value : "-";
        });
      } finally {
        summaryLoading.value = false;
      }
    }

    onMounted(() => fetchCandidateSummary());

    return {
      summary,
    };
  },
});
